import React from 'react';
import { motion } from 'framer-motion';
import { PROGRESS } from '../../config/designTokens';
interface ProgressBarProps {
  value: number; // 0 to 100
  max?: number;
  height?: number;
  color?: string;
  showLabel?: boolean;
  className?: string;
}
export function ProgressBar({
  value,
  max = 100,
  height = 12,
  // IMPROVED: Larger default height
  color = PROGRESS.barColor,
  showLabel = false,
  className = ''
}: ProgressBarProps) {
  const percentage = Math.min(100, Math.max(0, value / max * 100));
  return <div className={`w-full ${className}`} data-id="element-2488">
      {showLabel && <div className="flex justify-between text-sm font-bold text-slate-700 mb-2 uppercase tracking-wide" data-id="element-2489">
          <span data-id="element-2490">Voortgang</span>
          <span data-id="element-2491">{Math.round(percentage)}%</span>
        </div>}
      <div className="w-full bg-slate-100 rounded-full overflow-hidden shadow-inner border border-slate-200/50" role="progressbar" aria-valuenow={Math.round(percentage)} aria-valuemin={0} aria-valuemax={100} aria-label={`Voortgang: ${Math.round(percentage)}%`} style={{
      height
    }} data-id="element-2492">
        <motion.div className={`h-full rounded-full ${color} relative overflow-hidden`} initial={{
        width: 0
      }} animate={{
        width: `${percentage}%`
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-2493">
          {/* Shine effect overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent w-full h-full -translate-x-full animate-[shimmer_2s_infinite]" data-id="element-2494" />
        </motion.div>
      </div>
    </div>;
}
interface ProgressRingProps {
  progress: number;
  size?: number;
  strokeWidth?: number;
  color?: string;
  trackColor?: string;
  showLabel?: boolean;
  className?: string;
}
const isDirectColor = (c: string) => c.startsWith('#') || c.startsWith('rgb');
export function ProgressRing({
  progress,
  size = 64,
  strokeWidth = 6,
  color = PROGRESS.ringColor,
  trackColor = 'text-slate-100',
  showLabel = true,
  className = ''
}: ProgressRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - progress / 100 * circumference;
  const useDirectColor = isDirectColor(color);
  const useDirectTrack = isDirectColor(trackColor);
  return <div className={`relative flex items-center justify-center ${className}`} role="progressbar" aria-valuenow={Math.round(progress)} aria-valuemin={0} aria-valuemax={100} aria-label={`Voortgang: ${Math.round(progress)}%`} style={{
    width: size,
    height: size
  }} data-id="element-2495">
      <svg className="transform -rotate-90" width={size} height={size} data-id="element-2496">
        {/* Background Circle */}
        <circle className={useDirectTrack ? undefined : trackColor} strokeWidth={strokeWidth} stroke={useDirectTrack ? trackColor : 'currentColor'} fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-2497" />
        {/* Progress Circle */}
        <motion.circle className={useDirectColor ? 'drop-shadow-sm' : `${color} drop-shadow-sm`} strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={circumference} animate={{
        strokeDashoffset: offset
      }} transition={{
        type: 'spring',
        stiffness: 50,
        damping: 20,
        duration: 1.5
      }} strokeLinecap="round" stroke={useDirectColor ? color : 'currentColor'} fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-2498" />
      </svg>
      {showLabel && <motion.div initial={{
      opacity: 0,
      scale: 0
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.5,
      type: 'spring'
    }} className="absolute text-sm font-black text-slate-800" data-id="element-2499">
          {Math.round(progress)}%
        </motion.div>}
    </div>;
}